import { render } from "./IntercomConversationCard.vue?vue&type=template&id=79232771"
import script from "./IntercomConversationCard.vue?vue&type=script&lang=js"
export * from "./IntercomConversationCard.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./IntercomConversationCard.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_881c333e%2Fpackages%2Fbo%2Fsrc%2Fcomponents%2Fintercom%2FIntercomConversationCard.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__